import wrapperHOC from "@Utils/wrapperHOC";
import useAppPadding from "hooks/useAppPadding";
import useIsApp from "hooks/useIsApp";
import React from "react";

interface AppSafeAreaSpacerProps {
  styles?: React.CSSProperties;
  enabled?: boolean;
}

const AppSafeAreaSpacer: React.FC<AppSafeAreaSpacerProps> = ({ styles, enabled = true }) => {
  const isApp = useIsApp();
  const appPadding = useAppPadding();
  const finalStyles: React.CSSProperties = {
    height: appPadding,
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "#fff",
    ...styles,
  };
  const safeAreaHeight = finalStyles?.height;

  if (!enabled || !safeAreaHeight || !isApp) return null;

  return <div style={finalStyles} />;
};

export default wrapperHOC(AppSafeAreaSpacer, {
  componentName: "AppSafeAreaSpacer",
  showForChina: true,
});
